export const ExtCostVariationComponent = {
    SST_COST: 22,
    F2F_COST: 19,
    SVC_COST: 20,
    STC_COST: 21,
    CORE_COST: 142,
    LF_COST: 146,
    GA_CLINICAL: 134,
    GA_WL: 138,
    MANAGEMENTFEE: 1000,
    PEPM_COST: 1001,
    ENHANCEDLEGAL: 10000,
    ENHANCEDFINANCIAL: 10001,
    WELLNESSCOACHING: 10002,
};

export const ApiCalls = {
    PERCENTDELIVERYWPOEXTAFF: 1,
    SESSIONUSAGES: 2,
    TASKCOSTS: 3,
    EXTERNALCOSTSMIN: 4,
    SERVICEDISTRIBUTION: 5,
    COUNTRYUTILIZATION: 6,
    CALCULATION: 7,
};

export const ENHANCEDLEGALFINANCIALCOMPONENTENUM = {
    ENHANCEDLEGAL: 10000,
    ENHANCEDFINANCIAL: 10001,
}